import React, { useContext, useEffect, useState } from "react";
import { firebase } from "../constants/firebase";
import { UserContext } from "../containers/UserProvider";

export const EmojiContainer = ({ commentId, replyId }) => {
  const user = useContext(UserContext);
  const [emojis, setEmojis] = useState([]);
  const db = firebase.firestore();
  const path = commentId
    ? `comments/${commentId}/emojis`
    : `replies/${replyId}/emojis`;

  useEffect(() => {
    db.collection(path)
      .orderBy("voteCount", "desc")
      .onSnapshot((snapshot) => {
        setEmojis(snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
      });
  }, [db]);

  const getReactionColor = (emoji) => {
    return emoji.voters?.filter((voter) => !voter.id?.includes(user?.uid))
      ?.length !== emoji.voters?.length
      ? "blue-400 border border-blue-400 bg-opacity-20"
      : "gray-600";
  };

  const clickEmoji = (emoji) => {
    db.collection(path)
      .doc(emoji)
      .get()
      .then((doc) => {
        const { voteCount, voters } = doc.data();
        // All the voters except the current user
        const votersMinusCurUser = voters.filter((voter) => {
          if (voter.id) {
            return !voter.id.includes(user.uid);
          } else {
            return !voter.includes(user.uid);
          }
        });
        if (votersMinusCurUser.length === voters.length) {
          // If the current user has not voted on this comment yet
          doc.ref.update({
            voteCount: voteCount + 1,
            voters: [...voters, db.doc(`users/${user.uid}`)],
          });
        } else if (voteCount === 1) {
          // If the current user redacts his vote for this emoji, remove the emoji completely
          // if there are no other votes for it
          doc.ref.delete();
        } else {
          // If the current user redacts his vote for this emoji, decrease the vote count and
          // remove this user from its voter list
          doc.ref.update({
            voteCount: voteCount - 1,
            voters: votersMinusCurUser,
          });
        }
      });
  };

  return (
    <div>
      <div className="flex w-full py-1 text-white items-center">
        {emojis.map((emoji) => (
          <React.Fragment key={emoji.id}>
            <div className="flex">
              <button
                className={`bg-${getReactionColor(
                  emoji
                )} outline-none mr-1 rounded-lg px-2 py-1 flex items-center text-xs`}
                type="button"
                disabled={!user}
                onClick={(e) => clickEmoji(emoji.id)}
              >
                {emoji.unicode}
                <span className="ml-3">{emoji.voteCount}</span>
              </button>
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};
